<template>
  <div class="match-score" :style="{'top': top}">
    <iframe class="player-score-iframe" :src="iframeUrl" frameborder="0"></iframe>
  </div>
</template>

<script>
  import { record } from '@/util/util.js'
  export default {
    props: ['matchId', 'scoreTabInfo'],
    data() {
      return {
        top: '17.2rem',
        iframeUrl: ''
      }
    },
    mounted() {
      let matchId = Number(this.matchId) - 50000000
      let matchPlayerScoreBaseUrl = 'https://n.allfootballapp.com'
      if (process.env.NODE_ENV === 'development' || location.hostname.startsWith('beta')) {
        matchPlayerScoreBaseUrl = 'https://beta-n.allfootballapp.com'
      }
      this.iframeUrl = `${matchPlayerScoreBaseUrl}/v2/matchPlayerScore?match_id=${matchId}&sport_type=${this.scoreTabInfo.sport_type || 'soccer'}&tab_id=${this.scoreTabInfo.tab_id}`
      const iframeContainerEle = document.getElementById('contentWrap')
      if (iframeContainerEle) {
        this.top = getComputedStyle(iframeContainerEle).top || '17.2rem'
      }
      record(`msite/matchPlayerScore?action=view&matchId=${matchId}`)
    },
  }
</script>

<style lang="less" scoped>
.match-score {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  .player-score-iframe {
    width: 100%;
    // height: calc(100vh - 17.2rem);
    height: 100%;
    margin: 0;
    padding: 0;
    border: none;
    display: block;
    overflow: hidden;

    #document {
      margin: 0;
      padding: 0;
      border: none;
    }
  }

  .player-score-iframe::-webkit-scrollbar { 
    width: 0 !important;
    height: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// matchScore.vue?7695669b